export default __webpack_public_path__ + "efc01dd1ea2b14e24a4456e87addac60.svg";